import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
export default function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}